import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'amfe-flexible'
import apiObj from '@a/js/api.js'
import storeLocal from 'storejs'

// 样式重置
import '@/assets/styles/reset.css'
import '@/assets/styles/formSty.less'
import '@/assets/fonts/remixicon.css'
import '@/assets/styles/pcsty.less'

Vue.config.devtools = apiObj.VUE_APP_NAME !== 'production'

import { Button, Toast } from 'vant'

Vue.use(Button)
Vue.use(Toast)

Vue.config.productionTip = false
Vue.prototype.$AppName = 'booking'
Vue.prototype.$storeLocal = storeLocal

// 多语言组件
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "zh", // 语言标识
  messages: {
    "zh": require("@a/js/lang/zh-CN"),
    "en": require("@a/js/lang/en-US")
  }
});

// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)

new Vue({
  router,
  i18n,
  data: () => {
    return {
      isVersion: 0,
      isJump: 0,
      jumpUrl: '',
      language: 'zh',
      // 进入项目的第一个页面
      firstPage: '',
      currentPage: ''
    }
  },
  render: h => h(App)
}).$mount('#app')
